import React, { Component, Fragment } from "react";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import { inject, observer } from "mobx-react";
import loadable from "@loadable/component";

import { firebaseApp } from "src/config/firebase";
import ScrollToTop from "src/components/ui/ScrollToTop";
import { shouldShowSidebar } from "src/components/Sidebar/sidebar.utils";

// Import all routes
import allRoutes from "../../routes";

// Lazy load components
const TopNav = loadable(() => import("src/components/TopNav"));
const Footer = loadable(() => import("src/components/Footer"));
const Sidebar = loadable(() => import("src/components/Sidebar/index"));

@inject("store")
@observer
export default class Routers extends Component {
  constructor(props) {
    super(props);

    this.props.store.checkAuth();

    var iOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;

    if (iOS) {
      document.getElementById("body").style.cursor = "pointer";
    }

    firebaseApp
      .database()
      .ref("/.info/serverTimeOffset")
      .once("value")
      .then(
        (data) => {
          this.props.store.setServerTimeOffset(data.val());
        },
        (err) => {
          return err;
        }
      );
  }

  render() {
    const { store } = this.props;
    const isAuthenticated = store?.authenticated;

    return (
      <Router>
        <ScrollToTop>
          <Route
            render={({ location }) => {
              const hasSidebar = shouldShowSidebar(location, isAuthenticated);
              // Navbar ditampilkan saat login, kecuali di halaman Dashboard (Daftar Ujian) agar tidak dobel
              const isDashboard = location?.pathname === "/dashboard" || location?.pathname?.startsWith("/dashboard/");
              const shouldShowTopNav = isAuthenticated && !isDashboard;

              return (
                <Fragment>
                  <Sidebar {...this.props} />
                  <div
                    id="main-content-wrapper"
                    style={
                      !hasSidebar
                        ? { marginLeft: 0 }
                        : undefined
                    }
                  >
                    {shouldShowTopNav && <TopNav {...this.props} />}
                    <Switch>{allRoutes}</Switch>
                    <Footer {...this.props} />
                  </div>
                </Fragment>
              );
            }}
          />
        </ScrollToTop>
      </Router>
    );
  }
}
